import {
  TrackingPageTypeWithId,
  TrackingPageTypeWithoutId,
} from '../../../types';
import {
  DetailedPageInfo,
  TrackingClientStateHolder,
} from '../helpers/clientState';
import {trackContentView} from './trackContentView';

export const replayLastContentViewBefore =
  (pageType: TrackingPageTypeWithId | TrackingPageTypeWithoutId) =>
  (clientState: TrackingClientStateHolder) => {
    const pageHistory = clientState.getCurrent().pageHistory;

    // pick the contentView before the given page type
    const lastContentViewBeforeTheGivenPageType = pageHistory
      .reverse()
      .find(({page: {type}}) => type !== pageType);

    return trackContentView(
      lastContentViewBeforeTheGivenPageType as DetailedPageInfo
    )(clientState);
  };
